// Use $ instead of $ without replacing global $
(function ($) {
  $(document).ready(function () {
    var australiaSpan = $('.accordion ul.inner li span:contains("Australia")');
  
    australiaSpan.each(function () {
      var siblingUL = $(this).siblings('ul.inner');
  
      var matchingLi = siblingUL.find('li h6').filter(function () {
        return $.trim($(this).text()) === 'Australia After Hours Field Service';
      });
  
      if (matchingLi.length > 0) {
        matchingLi.closest('li').find('.btn-default').hide();
      } 
    });
  });
  
  // tabs function

  $('.toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $this = $(this);

    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.next().stop(true, true).slideUp(350);
      // $this.parent().find('.toggle.sub-toggle').removeClass('rotate-arrow');
      $this.parent().find('.inner.address-inner').stop(true, true).slideUp(350);
    } else {
      $this.next().toggleClass('show');
      $this.next().stop(true, true).slideToggle(350);
      //Open only one at a time and close rest.
      // $this.parent().parent().find('li .inner').removeClass('show');
      // $this.parent().parent().find('li .inner').stop(true, true).slideUp(350);
    }

    if (!$this.hasClass('rotate-arrow')) {
      // $this.parent().parent().find('li .inner .sub-toggle').removeClass('rotate-arrow');
    }
  });

  $('.toggle.primary').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $this = $(this);

    $this.toggleClass('rotate-arrow');

    if (!$this.hasClass("rotate-arrow")) {
      $('.toggle.sub-toggle').removeClass('rotate-arrow');
      $('.toggle.sub-toggle').next().removeClass('show');
    }

  });


  $('.toggle.sub-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $this = $(this);

    $this.toggleClass('rotate-arrow');

  });

  $('.all-open .single-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $this = $(this);

    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.next().stop(true, true).slideUp(350);
      $this.parent().find('.single-toggle').removeClass('rotate-arrow');
      $this.parent().find('.inner.address-inner').stop(true, true).slideUp(350);
    } else {
      $this.next().toggleClass('show');
      $this.next().stop(true, true).slideToggle(350);
      $this.toggleClass('rotate-arrow');
    }

  });

  //Open only one at a time and close rest.
  $('.one-down .single-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $this = $(this);
    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.removeClass('rotate-arrow');
      $this.next().stop(true, true).slideUp(350);
    } else {
      $this.parents().find('.primary').removeClass('rotate-arrow')
      $this.parents().find('li .inner').removeClass('show');
      $this.parents().find('li .inner').stop(true, true).slideUp(350);
      $this.next().toggleClass('show');
      $this.toggleClass('rotate-arrow');
      $this.next().stop(true, true).slideToggle(350);
    }


  });

  $(window).on("load", function () {
    $('.accordion .main-accordion>li>.inner li .address-inner .address').unwrap();


    // Email us overlay
    $(document).on('click', 'body .accordion .main-accordion>li>.inner li .address-inner .address .row .email-us a', function (e) {
      e.preventDefault();
      $('#email-overlay').addClass('overlay-active');
      $('body').addClass('email-overlay-active');
    });

    $('body .email-overlay .form-wrapper').on('click', function (event) {
      event.stopPropagation();
    });

    function close_email_overlay() {
      $('.email-overlay .close-btn, .email-overlay .v-middle-wrapper').on('click', function () {
        $('.email-overlay').removeClass('overlay-active');
        $('body').removeClass('email-overlay-active');
      });
    }

    close_email_overlay()

    var email_image = $('body .email-overlay .form-wrapper .bg-img img');
    objectFitImages(email_image);
  });

})(jQuery);